module.exports = __webpack_public_path__ + "static/media/done3.66fd4dde.gif";